module.exports = __webpack_public_path__ + "img/ai-tic-tac-toe-4.5870f527.png";